import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-scroll'; // Re-import Link from react-scroll
import { useLocation } from 'react-router-dom'; // To check current path
import './Header.css';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation(); // Get current location

  const handleScroll = useCallback(() => {
    if (typeof window !== 'undefined') {
      const heroSection = document.getElementById('hero');
      let heroHeight = 0;
      if (heroSection && location.pathname === '/') { // Only consider hero height on the homepage
        heroHeight = heroSection.offsetHeight;
      }

      // If not on the homepage, or if on homepage but scrolled past hero, set isScrolled to true
      // Otherwise, if on homepage and within hero, set isScrolled based on scroll position
      if (location.pathname !== '/') {
        setIsScrolled(true); // Always white background on other pages
      } else {
        setIsScrolled(window.scrollY > heroHeight - 70); // -70px to make it white when header is fully above hero
      }
    }
  }, [location.pathname]); // Dependency on location.pathname to re-evaluate heroHeight logic

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener('scroll', handleScroll);
      // Call handleScroll once on mount to set initial state
      handleScroll();
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }
  }, [handleScroll]);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`header ${isScrolled ? 'header--scrolled' : ''}`}>
      <div className="header-container">
        <div className="logo">
          <a href="/">Momentup</a>
        </div>
        <nav>
          <div className="hamburger" onClick={toggleMenu}>
            <div></div>
            <div></div>
            <div></div>
          </div>
          <ul className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
            <li><Link to="hero" smooth={true} duration={500} onClick={closeMenu}>소개</Link></li>
            <li><Link to="contest" smooth={true} duration={500} onClick={closeMenu}>공모전</Link></li>
            <li><Link to="funding" smooth={true} duration={500} onClick={closeMenu}>펀딩</Link></li>
            <li><Link to="column" smooth={true} duration={500} onClick={closeMenu}>칼럼</Link></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
